import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress'

interface SpinnerProps extends CircularProgressProps {
  fullScreen?: boolean
}

const Spinner = ({
  fullScreen = false,
  'aria-label': ariaLabel = 'Loading...',
  sx,
  ...props
}: SpinnerProps): JSX.Element => {
  const styleProps = {
    margin: fullScreen ? '3rem auto' : '2rem',
  }

  return (
    <CircularProgress
      sx={{ display: 'block', ...styleProps }}
      aria-label={ariaLabel}
      {...props}
    />
  )
}

export default Spinner
